export default __webpack_public_path__ + "static/shopifybadge-8192b727b5866d024ce4649ab977fca6.png";